import _ from 'lodash';
export const monthTyps = ['weekday', 'weekend', 'totalDt', 'overtime', 'overrate']
export const weekTyps = ['weekday', 'weekend', 'totalDt', 'overtime', 'overrate'];
export const dayTyps = ['day', 'overtime', 'overrate'];



export const getValueByDate = () => {
    return { weekday: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`, weekend: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`, totalDt: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}` }
}

export const monthData = {
    weekday: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    weekend: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    totalDt: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    overtime: `${_.random(-5, 10)} 시간`,
    overrate: `${_.random(1, 100)} %`
};
export const weekData = {
    weekday: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    weekend: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    totalDt: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    overtime: `${_.random(-5, 10)} 시간`,
    overrate: `${_.random(1, 100)} %`
};
export const dayData = {
    day: `${Math.floor(Math.random() * 100)}:${Math.floor(Math.random() * 59)}`,
    overtime: `${_.random(-5, 10)} 시간`,
    overrate: `${_.random(1, 100)} %`
}

export const plnObjForMonths = {
    'b31f2024-7c82-4adb-a916-4a5c0b9dc30a': { count: Math.floor(Math.random() * 1000) },
    '87d41567-a647-4a9b-a568-1b429eb26fa4': { count: Math.floor(Math.random() * 1000) },
    '91053dfd-a735-44d6-8db4-0dccc9807be8': { count: Math.floor(Math.random() * 1000) },
    '13e2ef43-01b9-4252-a22f-b096a1efedfa': { count: Math.floor(Math.random() * 1000) },
    '37457632-a078-4187-88db-d00a367257a5': { count: Math.floor(Math.random() * 1000) },
    'fc8e7038-ba55-4758-b781-c28f6caced85': { count: Math.floor(Math.random() * 1000) },
    "c3709acf-7893-4a2e-89d9-528c52174f0b": { count: Math.floor(Math.random() * 1000) },
    "total": { count: Math.floor(Math.random() * 1000) },
}

export const plnObjForWeeks = {
    'b31f2024-7c82-4adb-a916-4a5c0b9dc30a': { count: Math.floor(Math.random() * 1000) },
    '87d41567-a647-4a9b-a568-1b429eb26fa4': { count: Math.floor(Math.random() * 1000) },
    '91053dfd-a735-44d6-8db4-0dccc9807be8': { count: Math.floor(Math.random() * 1000) },
    '13e2ef43-01b9-4252-a22f-b096a1efedfa': { count: Math.floor(Math.random() * 1000) },
    '37457632-a078-4187-88db-d00a367257a5': { count: Math.floor(Math.random() * 1000) },
    'fc8e7038-ba55-4758-b781-c28f6caced85': { count: Math.floor(Math.random() * 1000) },
    "c3709acf-7893-4a2e-89d9-528c52174f0b": { count: Math.floor(Math.random() * 1000) },
    "total": { count: Math.floor(Math.random() * 1000) },
}

export const plnObjForDays = {
    'b31f2024-7c82-4adb-a916-4a5c0b9dc30a': { count: Math.floor(Math.random() * 1000) },
    '87d41567-a647-4a9b-a568-1b429eb26fa4': { count: Math.floor(Math.random() * 1000) },
    '91053dfd-a735-44d6-8db4-0dccc9807be8': { count: Math.floor(Math.random() * 1000) },
    '13e2ef43-01b9-4252-a22f-b096a1efedfa': { count: Math.floor(Math.random() * 1000) },
    '37457632-a078-4187-88db-d00a367257a5': { count: Math.floor(Math.random() * 1000) },
    'fc8e7038-ba55-4758-b781-c28f6caced85': { count: Math.floor(Math.random() * 1000) },
    "c3709acf-7893-4a2e-89d9-528c52174f0b": { count: Math.floor(Math.random() * 1000) },
    "total": { count: Math.floor(Math.random() * 1000) },
}


export const makeDataForMonths = (data) => {
    techDataForMonths.children.map((hq, index) => {
        hq.children.map((dp, dpIndex) => {
            dp.children.map((emp, empIndex) => {
                return _.merge(emp, data);
            })
        })
    })
    return Array.from([techDataForMonths]);
}

export const makeDataForWeeks = (data) => {
    techDataForWeeks.children.map((hq, index) => {
        hq.children.map((dp, dpIndex) => {
            dp.children.map((emp, empIndex) => {
                return _.merge(emp, data);
            })
        })
    })
    return Array.from([techDataForWeeks]);
}

export const makeDataForDays = (data) => {
    techDataForDays.children.map((hq, index) => {
        hq.children.map((dp, dpIndex) => {
            dp.children.map((emp, empIndex) => {
                return _.merge(emp, data);
            })
        })
    })
    return Array.from([techDataForDays]);
}

export const techDataForMonths = {
    id: 'root',
    name: 'HCINFO',
    rowSpan: 24,
    children: [
        {
            id: '1', name: '기술지원본부', rowSpan: 24, children: [
                {
                    id: '1-1', name: '인프라기술1팀', rowSpan: 24, children: [
                        { id: '1-1-1', name: '김두섭 부장', rowSpan: 8 },
                        { id: '1-1-2', name: '이주형 대리', rowSpan: 8 },
                        { id: '1-1-3', name: '임수환 대리', rowSpan: 8 },
                        // { id: '1-1-4', name: '오미라 주임', rowSpan: 8 },
                        // { id: '1-1-5', name: '원민중 주임', rowSpan: 8 },
                        // { id: '1-1-6', name: '강예은 주임', rowSpan: 8 },
                        // { id: '1-1-7', name: '윤다연 주임', rowSpan: 8 }
                    ]
                }
            ]
        }
    ]
}

export const techDataForWeeks = {
    id: 'root',
    name: 'HCINFO',
    rowSpan: 24,
    children: [
        {
            id: '1', name: '기술지원본부', rowSpan: 24, children: [
                {
                    id: '1-1', name: '인프라기술1팀', rowSpan: 24, children: [
                        { id: '1-1-1', name: '김두섭 부장', rowSpan: 8 },
                        { id: '1-1-2', name: '이주형 대리', rowSpan: 8 },
                        { id: '1-1-3', name: '임수환 대리', rowSpan: 8 },
                        // { id: '1-1-4', name: '오미라 주임', rowSpan: 8 },
                        // { id: '1-1-5', name: '원민중 주임', rowSpan: 8 },
                        // { id: '1-1-6', name: '강예은 주임', rowSpan: 8 },
                        // { id: '1-1-7', name: '윤다연 주임', rowSpan: 8 }
                    ]
                }
            ]
        }
    ]
}

export const techDataForDays = {
    id: 'root',
    name: 'HCINFO',
    rowSpan: 24,
    children: [
        {
            id: '1', name: '기술지원본부', rowSpan: 24, children: [
                {
                    id: '1-1', name: '인프라기술1팀', rowSpan: 24, children: [
                        { id: '1-1-1', name: '김두섭 부장', rowSpan: 8 },
                        { id: '1-1-2', name: '이주형 대리', rowSpan: 8 },
                        { id: '1-1-3', name: '임수환 대리', rowSpan: 8 },
                        // { id: '1-1-4', name: '오미라 주임', rowSpan: 8 },
                        // { id: '1-1-5', name: '원민중 주임', rowSpan: 8 },
                        // { id: '1-1-6', name: '강예은 주임', rowSpan: 8 },
                        // { id: '1-1-7', name: '윤다연 주임', rowSpan: 8 }
                    ]
                }
            ]
        }
    ]
}